import { Container, Typography } from '@cleartrip/ct-design-components'
import React from 'react'

import { CTA_URL, FAQS } from './constants'
import { ChevronDownIcon } from './icons'
import styles from './VdcEducationPage.module.scss'

interface FAQProps {
  expandedFaqs: Set<number>
  onToggle: (index: number) => void
}

const Faq: React.FC<FAQProps> = ({ expandedFaqs, onToggle }) => (
  <Container className={`${styles.faq} flex flex-column`}>
    {FAQS.map((faq, index) => (
      <Container key={index}>
        <Container className={`${styles['faq__item']} c-pointer`} onClick={() => onToggle(index)}>
          <Container className={`${styles['faq__header']} flex flex-between flex-middle`}>
            <Typography className={styles['faq__question']} variant="B1">{faq.question}</Typography>
            <div className={`${styles['faq__chevron']} ${expandedFaqs.has(index) ? styles['faq__chevron--expanded'] : ''}`}>
              <ChevronDownIcon isExpanded={expandedFaqs.has(index)} />
            </div>
          </Container>
        </Container>
        {expandedFaqs.has(index) && (
          <Container className={styles['faq__answer']}>
            {faq.answer.map((section, sectionIndex) => (
              <Container key={sectionIndex} className={styles['faq__answerSection']}>
                {section.text && (
                  <Typography 
                    variant="P2" 
                    className={styles['faq__answerText']}
                    dangerouslySetInnerHTML={{ __html: section.text }}
                  />
                )}
                {section.list && (
                  <Container className={styles['faq__list']}>
                    {section.list.map((item, itemIndex) => (
                      <Typography
                        key={itemIndex}
                        variant="P2"
                        className={styles['faq__listItem']}
                        dangerouslySetInnerHTML={{ __html: item.content }}
                      />
                    ))}
                  </Container>
                )}
              </Container>
            ))}
          </Container>
        )}
        {index < FAQS.length - 1 && <div className={styles['faq__divider']} />}
      </Container>
    ))}
    <Container
      className={`${styles['faq__cta']} c-pointer`}
      onClick={() => window.open(CTA_URL, '_blank', 'noopener,noreferrer')}
    >
      <Typography className={styles['faq__ctaText']} variant="B3">View all terms and conditions</Typography>
    </Container>
  </Container>
)

export default Faq

